export default "__VITE_ASSET__g4Y_5CUC__"